import {useMemo} from 'react';

import {usePart, useParts} from '../hooks';
import {type WholeFromTypeWithRef} from '../types';
import type * as DiscussionThreadTypes from './types';

export function useDiscussionThread(
  ref: DiscussionThreadTypes.Ref
): WholeFromTypeWithRef<'discussion-thread'> {
  const part = usePart(ref);
  const comments = useParts(part.commentRefs);
  return useMemo(() => ({...part, comments, ref}), [ref, part, comments]);
}

export function useDiscussionThreads(
  refs: DiscussionThreadTypes.Ref[]
): Array<WholeFromTypeWithRef<'discussion-thread'>> {
  const parts = useParts(refs);
  const flatComments = useMemo(
    () => parts.flatMap(p => p.commentRefs),
    [parts]
  );
  const comments = useParts(flatComments);

  return useMemo(() => {
    const offsets = [0];
    for (const p of parts) {
      offsets.push(offsets[offsets.length - 1] + p.commentRefs.length);
    }

    return parts.map((p, i) => ({
      ...p,
      comments: comments.slice(offsets[i], offsets[i + 1]),
      ref: refs[i],
    }));
  }, [parts, comments, refs]);
}
